import React, { useState } from 'react'
import { Box, TextField, ButtonProps } from '@mui/material'
import { useTranslation } from 'react-i18next'
import BasicModal from '@/components/UI/Dialog'

const DocumentRename = (props: any) => {
  const { t } = useTranslation('translation')
  const [name, setName] = useState('')

  const footerActions = [
    {
      title: t('Cancel'),
      variant: 'outlined' as const,
      color: 'primary' as ButtonProps['color'],
      onClick: props.onHide,
    },
    {
      title: t('Save Changes'),
      variant: 'outlined' as const,
      color: 'primary' as ButtonProps['color'],
      onClick: () => props.footerButtonAction(name),
      disabled: !name || name.trim().length === 0,
    },
  ]

  return (
    <BasicModal
      open={props.show}
      onClose={props.onHide}
      sx={{ width: '500px', height: 'auto' }}
      title={t('Rename Document')}
      footerActions={footerActions}
    >
      <Box mt={2}>
        <TextField
          fullWidth
          label={t('Document Name')}
          value={name}
          onChange={e => setName(e.target.value)}
          placeholder={props.documentName}
          size="small"
          autoFocus
        />
      </Box>
    </BasicModal>
  )
}

export default DocumentRename
